import markItemsJunkNotJunkFromTable from './helpers/markItemsJunkNotJunkFromTable';
import markConversationsJunkNotJunkFromTable from './helpers/markConversationsJunkNotJunkFromTable';
import { TableView } from 'owa-mail-list-store';
import { ActionSource, logUsage } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getInboxClassificationFilterForTable } from 'owa-mail-list-store';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util';

/**
 * Mark the rows as junk or not junk
 * @param rowKeys of the rows to be marked as junk/not junk
 * @param tableView that contains the rows
 * @param isJunkValueToSet whether to mark as junk or not junk
 * @param actionSource the action source
 */
export default function markRowsJunkNotJunkFromTable(
    rowKeys: string[],
    tableView: TableView,
    isJunkValueToSet: boolean,
    actionSource: ActionSource
) {
    if (isInboxPlusEnabled() && folderNameToId('inbox') === tableView.tableQuery.folderId) {
        logUsage(
            'InboxPlusJunk',
            [getInboxClassificationFilterForTable(tableView.id), isJunkValueToSet],
            {
                isCore: true,
            }
        );
    }

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            markConversationsJunkNotJunkFromTable(
                rowKeys,
                tableView,
                isJunkValueToSet,
                actionSource
            );
            break;

        case ReactListViewType.Message:
            markItemsJunkNotJunkFromTable(rowKeys, tableView, isJunkValueToSet, actionSource);
            break;
    }
}
